import { layout } from './tokens';

/**
 * GABARITS D'AFFICHAGE : la seule règle qui décide si l'application est un téléphone, une tablette
 * ou un ordinateur. Elle est ici, pure et sans dépendance, pour être vérifiée sans rendu.
 *
 * - compact : moins de `layout.seuilMoyen` px. L'application du téléphone, inchangée.
 * - moyen   : de `seuilMoyen` à `seuilEtendu` (exclu). Tablette ou petite fenêtre : rail d'icônes.
 * - etendu  : `seuilEtendu` et plus. Ordinateur : barre latérale.
 *
 * LA GARANTIE SUR APPAREIL EST STRUCTURELLE : hors du web, la fonction rend `compact` sans regarder
 * la largeur. Un téléphone ne peut pas passer en gabarit large par accident d'arithmétique, et les
 * écrans y rendent l'arbre qu'ils rendaient avant ce lot. Le jour où l'application gérera la
 * tablette en natif (`ios.supportsTablet`), c'est cette ligne, et elle seule, qu'il faudra ouvrir.
 */
export type Gabarit = 'compact' | 'moyen' | 'etendu';

export function gabaritPour(largeur: number, surLeWeb: boolean): Gabarit {
  if (!surLeWeb) return 'compact';
  if (largeur >= layout.seuilEtendu) return 'etendu';
  if (largeur >= layout.seuilMoyen) return 'moyen';
  return 'compact';
}
